import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: '[qaroni-payments-level-line]',
  templateUrl: './payments-level-line.component.html',
  styleUrls: ['./payments-level-line.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaymentsLevelLineComponent {}
